module.exports = "/education/modal-schedule-published-1a5985.html";